/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormControl, ValidatorFn, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { OverlayListenerOptions, OverlayOptions } from 'primeng/api';

@Component({
    selector: 'drop-down',
    templateUrl: './drop-down.component.html',
    styleUrls: ['./drop-down.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DropDownComponent {
    @Input() control: FormControl<any> = new FormControl('');
    @Input() filter = false;
    @Input() filterBy!: string;
    @Input() label!: string;
    @Input() optionLabel!: string;
    @Input() optionValue!: string;
    @Input() options: any[] = [];
    @Input() showClear = false;
    @Input() placeholder: string = '';
    @Input() showError = false;
    @Input() required = false;
    @Input() virtualScroll = false;
    @Input() virtualScrollItemSize: number = 30;
    @Input() emptyFilterMessage = 'noResultsFound';
    @Output() selectionChange = new EventEmitter();

    requiredValidator: ValidatorFn = Validators.required;

    protected deviceWidth: number = window.innerWidth;

    constructor (private translateService: TranslateService) { }

    optionChanged (event: any) {
        this.selectionChange.emit(event.value);
    }
    ngOnInit () {
        if (!this.placeholder) {
            this.placeholder = `${this.translateService.instant('pleaseSelect')} ${this.label ? this.label : ''}`.trim();
        }
    }

    getOverlayOptions (): OverlayOptions {
        return {
            listener: (event: Event, options?: OverlayListenerOptions) => {
                if (options?.type === 'scroll' || options?.type === 'resize') {
                    return false;
                }
                return options?.valid;
            }
        };
    }

    isObjectArray () {
        return this.options.length > 0 && typeof this.options[0] === 'object';
    }
}
